import _ from "lodash";
import React from "react";
import classes from "./EntityCohorts.scss";
import classNames from "classnames";
import { useI18n } from "Hooks";
import { Checkbox } from "@toddle-edu/ds-web";
import EntityCohortsDetailsComp from "../EntityCohortsDetails";
import {
  FORWARDED_MESSAGE_LIMIT,
  FORWARD_MESSAGE_VISIBILITY_CONFIG,
} from "Platform/routes/MessagingV2/modules/Utils";

const EntityCohortsDetails = props => {
  const {
    entityKey,
    entityData,
    selectedEntity,
    onEntitySelect,
    disableAllCheckBoxes = false,
  } = props;

  const channelSet = _.get(selectedEntity, "CHANNELS");
  const usersSet = _.get(selectedEntity, "USERS");

  const isChatSelected = usersSet.has(entityData.id);
  const isChannelSelected = channelSet.has(entityData.id);
  const isChecked = _.isEqual(
    FORWARD_MESSAGE_VISIBILITY_CONFIG.CHANNELS.key,
    entityKey
  )
    ? isChannelSelected
    : isChatSelected;

  return (
    <div className={classes.entityDetails}>
      <EntityCohortsDetailsComp entityData={entityData} entityKey={entityKey} />
      <Checkbox
        onChange={() =>
          onEntitySelect({
            type: entityKey,
            id: [entityData.id],
            isChecked,
            entity: entityData,
          })
        }
        isChecked={isChecked}
        disabled={disableAllCheckBoxes && !isChecked}
      />
    </div>
  );
};

const EntityCohorts = props => {
  const {
    entityKey,
    entityData = [],
    header,
    selectedEntity,
    onEntitySelect,
  } = props;
  const { t } = useI18n(["common"]);
  const chatMap = _.get(selectedEntity, "CHANNELS");
  const usersMap = _.get(selectedEntity, "USERS");

  const totalCount = _.size(chatMap) + _.size(usersMap);

  const disableAllCheckBoxes = totalCount >= FORWARDED_MESSAGE_LIMIT;

  const headerClass = classNames(classes.headerContainer, "text-label-2");

  if (!_.size(entityData)) {
    return null;
  }
  return (
    <div className={classes.container}>
      <div className={headerClass}>{t(header)}</div>
      {_.map(entityData, data => {
        return (
          <EntityCohortsDetails
            entityData={data.node}
            key={data.node.id}
            entityKey={entityKey}
            selectedEntity={selectedEntity}
            onEntitySelect={onEntitySelect}
            disableAllCheckBoxes={disableAllCheckBoxes}
          />
        );
      })}
    </div>
  );
};

export default EntityCohorts;
